import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSectionFormatter = ({
  section,
  onClick,
  usageTracker
}) => {
  const ActionButtons = section.actions;
  return /*#__PURE__*/_jsx(UIButtonWrapper, {
    className: "m-top-4",
    children: ActionButtons.map((action, idx) => {
      if (action.type === 'ACTION') {
        const copilotAction = Object.assign({}, action.payload, {
          text: action.text || ''
        });
        return /*#__PURE__*/_jsx(CopilotActionButton, {
          hideIcon: true,
          copilotAction: copilotAction,
          onClick: onClick,
          size: "xs",
          text: action.label,
          use: "tertiary",
          usageTracker: usageTracker,
          usageTrackerAppLocationKey: "copilot-preview:quick-action"
        }, idx);
      } else if (action.type === 'ACTION_V2') {
        var _payloadData$associat;
        const payloadData = JSON.parse(action.payload.payloadJson);
        const objectCoordinates = (_payloadData$associat = payloadData.associated_object) === null || _payloadData$associat === void 0 ? void 0 : _payloadData$associat.object_coordinates;
        const copilotAction = Object.assign({}, payloadData, {
          intent: action.payload.intent,
          text: action.text || ''
        }, action.label ? {
          objectTypeLabel: action.label
        } : {}, payloadData.task ? {
          task: payloadData.task
        } : {}, objectCoordinates !== null && objectCoordinates !== void 0 && objectCoordinates.objectId ? {
          objectId: objectCoordinates.objectId
        } : {}, objectCoordinates !== null && objectCoordinates !== void 0 && objectCoordinates.objectTypeId ? {
          objectTypeId: objectCoordinates.objectTypeId
        } : {});
        return /*#__PURE__*/_jsx(CopilotActionButton, {
          hideIcon: true,
          copilotAction: copilotAction,
          onClick: onClick,
          size: "xs",
          text: action.label,
          use: "tertiary",
          usageTracker: usageTracker,
          usageTrackerAppLocationKey: "copilot-preview:quick-action-v2"
        }, idx);
      } else if (action.type === 'LINK') {
        return /*#__PURE__*/_jsx(AIButton, {
          external: true,
          href: action.href,
          showBreezeIcon: false,
          size: "xs",
          use: "tertiary",
          usageTracker: usageTracker,
          usageTrackerAppLocationKey: "copilot-preview:quick-action-link",
          children: action.label
        }, idx);
      }
      return null;
    })
  });
};
export default ActionSectionFormatter;